import axios from 'axios';
import queryString from 'query-string';
import { sessionTimeout } from './actions';

const HEADERS = ['access-token', 'token-type', 'client', 'expiry', 'uid'];

export const setHeadersFromLocalStorage = () => {
  HEADERS.forEach((token) => {
    axios.defaults.headers.common[token] = localStorage.getItem(token);
  });
};

export const setHeaders = (headers) => {
  HEADERS.forEach((token) => {
    axios.defaults.headers.common[token] = headers[token];
    localStorage.setItem(token, headers[token]);
  });
};

export const deleteHeaders = () => {
  HEADERS.forEach((token) => localStorage.removeItem(token));
};

export function onAxiosResponse(response, store) {
  const { dispatch } = store;
  const {
    auth: { user },
  } = store.getState();

  // If user is logged in and receives a 401, their session has timed out
  if (response.status === 401 && user) {
    dispatch(sessionTimeout);
  }

  const { headers } = response;

  if (headers) {
    if (headers['access-token']) {
      setHeaders(headers);
    }
  }
}

// Validation helpers =====
export const passwordValidationRules = (password) => [
  {
    key: 'lowerChar',
    rule: 'One lowercase character',
    regex: RegExp(/(?=.*[a-z])/g),
  },
  {
    key: 'specialChar',
    rule: 'One special character',
    regex: RegExp(/(?=.*[-!$%^&*@#()_+|~=`{}[\]:";'<>?,./])/g),
  },
  {
    key: 'upperChar',
    rule: 'One uppercase character',
    regex: RegExp(/(?=.*[A-Z])/g),
  },
  {
    key: 'minChar',
    rule: '12 characters minimum',
    valid: password.length >= 12,
  },
  { key: 'number', rule: 'One number', regex: RegExp(/(?=.*\d)/g) },
];

export const isValidPassword = (password, passwordRules) => {
  let valid = true;
  passwordRules.forEach((rule) => {
    if (typeof rule.valid !== 'undefined' && !rule.valid) {
      valid = false;
    } else if (rule.regex && !rule.regex.test(password)) {
      valid = false;
    }
  });
  return valid;
};
// ===== Validation helpers

// Update URL with latest token (this prevents using an old token if they refresh the page)
// NOTE: Not using atm but could be used if we want server validation, which would require
// us to update the tokens.
export const updateTokensInURL = (newHeaders) => {
  // Only update URL if new token was sent
  if (newHeaders['access-token']) {
    const oldQueryString = window.location.href.split('?')[1];
    const params = queryString.parse(oldQueryString);

    params['access-token'] = newHeaders['access-token'];
    params.expiry = newHeaders.expiry;

    let newQueryString = '?';
    const paramKeys = Object.keys(params);

    paramKeys.forEach((key, idx) => {
      newQueryString += `${key}=${encodeURIComponent(params[key])}`;
      if (idx !== paramKeys.length - 1) newQueryString += '&';
    });

    window.history.replaceState(
      {},
      '',
      window.location.pathname + newQueryString + window.location.hash
    );
  }
};
